import React from 'react'

import Base from '../_Base'

const Menu = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M21 18a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2zm0-7a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2zm0-7a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2z"
      fillRule="evenodd"
    />
  </Base>
)

export default Menu
